import { CredentialType } from '@uac-au/advance-typings';
import { nonEmptyString } from 'schemas/common';
import { z } from 'zod';

const dateTypeSchema = z.union([
  z.literal('object'),
  z.literal('number'),
  z.literal('string'),
  z.literal('boolean'),
  z.literal('array'),
]);

const formSchemaObjectSchema = z.object({
  headings: z.array(nonEmptyString),
  matchingCriteria: z.array(nonEmptyString),
  subHeadings: z.array(nonEmptyString),
  schema: z.object({
    properties: z.object({}).catchall(
      z.object({
        order: z.number(),
        title: nonEmptyString,
        type: dateTypeSchema,
      }),
    ),
    required: z.array(nonEmptyString),
    title: nonEmptyString.optional(),
    type: dateTypeSchema,
  }),
});

export const formSchemaSchema = z.object({
  [CredentialType.EMPLOYMENT]: formSchemaObjectSchema,
  [CredentialType.PROFESSIONAL]: formSchemaObjectSchema,
  [CredentialType.SUBJECT]: formSchemaObjectSchema,
  [CredentialType.TERTIARY]: formSchemaObjectSchema,
});
